import React from "react";

import "./contactInfoBox.scss";






const contactInfoBox = (props) => (
  <div className="contact__info-box">
    <div>
      <img src={props.icon} alt="address" />
    </div>
    <div>
      <a href={props.textLine1Href} target="_blank" rel="noopener noreferrer">
        <p>{props.textLine1}</p>
      </a>
      <a href={props.textLine2Href} target="_blank" rel="noopener noreferrer">
        <p>{props.textLine2}</p>
      </a>
    </div>
  </div>
);

export default contactInfoBox;
